export default __webpack_public_path__ + "static/media/back.40d649b4.webm";